import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';

// reactstrap components
import { Card, CardBody, Form, Row, Col, Input, Button, FormGroup } from "reactstrap";

// components
import Loading from '../../components/Loading/Loading';
import MainCard from '../../components/MainCard/MainCard';

// services
import { showMessage } from '../../helpers/message';
import { getSessionCookie } from "../../helpers/cookies";

// api
import usuario_api from '../../api/usuario_api';

export default function TrocarSenha({ history }) {
    const navigate = useNavigate();
    const session = getSessionCookie();

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            senhaAntiga: '',
            novaSenha: '',
            confirmarSenha: ''
        }
    });

    const [showLoading, setshowLoading] = React.useState(false);

    function onChangeInput(e) {
        const { name, value } = e.target;
        setValue(name, value);
    }

    const onSubmit = (data) => {
        if (data.novaSenha.length < 5) {
            showMessage("Aviso", "Informe uma senha com no mínimo 5 dígitos", 'error', null);
            return;
        }

        if (data.novaSenha != data.confirmarSenha) {
            showMessage("Aviso", "A Nova Senha e a Confirmação da Nova Senha estão diferentes", 'error', null);
            return;
        }

        let json_submit = {
            usuario_Id: session.usuario_Id,
            senhaAntiga: data.senhaAntiga,
            novaSenha: data.novaSenha
        }

        setshowLoading(true);
        usuario_api.trocar_senha(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação realizada com sucesso!", 'success', function () {
                    navigate("/admin/inicio")
                });
            }
        })
            .catch(e => {
                setshowLoading(false);
                showMessage("Aviso", e.message, "error");
            });
    }

    return (
        <>
            {showLoading && (<Loading />)}
            <MainCard title={<><FontAwesomeIcon icon={faKey} /> Trocar Senha</>}>
                <Row>
                    <Col md="12">
                        <Form style={{ maxWidth: "95%", margin: "0 auto" }} onSubmit={handleSubmit(onSubmit)}>
                            <Row className='mb-4'>
                                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <label>* Senha Antiga</label>
                                        <Input type="password" id="senhaAntiga" name="senhaAntiga" invalid={errors.senhaAntiga ? true : false} {...register("senhaAntiga", { required: "* Campo obrigatorio" })} onChange={onChangeInput} />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label>* Nova Senha</label>
                                        <Input type="password" id="novaSenha" name="novaSenha" invalid={errors.novaSenha ? true : false} {...register("novaSenha", { required: "* Campo obrigatorio" })} onChange={onChangeInput} />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label>* Confirmar Senha</label>
                                        <Input type="password" id="confirmarSenha" name="confirmarSenha" invalid={errors.confirmarSenha ? true : false} {...register("confirmarSenha", { required: "* Campo obrigatorio" })} onChange={onChangeInput} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="text-center">
                                <Col md="12">
                                    <Button color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i> Salvar</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </MainCard>
        </>
    );
}